import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from '../styles.scss';
import FiltersDrawer from 'components/FiltersDrawer';
import ActiveSelect from 'components/formElements/ActiveSelect';

class WorkroomFilters extends Component {

  handleFilter = (key, value) => {
    const filters = { ...this.props.filters };
    filters[key] = value;

    this.props.handleFilterChange(filters);
  }

  handleActive = value => this.handleFilter('is_active', value)

  render() {
    const { filters, active, title, reset } = this.props;
    return (
      <FiltersDrawer
        title={title}
        active={active}
        toggle={this.props.onOverlayClick}
        reset={reset}
      >
        <ActiveSelect
          key="active"
          className={styles.dropdown}
          value={filters.is_active}
          onChange={this.handleActive}
        />
      </FiltersDrawer>
    );
  }
}

WorkroomFilters.propTypes = {
  handleFilterChange: PropTypes.func,
  onOverlayClick: PropTypes.func,
  filters: PropTypes.object,
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
  reset: PropTypes.func.isRequired,
};

export default WorkroomFilters;



// WEBPACK FOOTER //
// ./client/app/shared/components/Filters/WorkroomFilters/index.jsx